import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import styles from './TabsBarMobile.module.scss';
const TabsBarMobile = ({ mode, modeSelected, items, value, onChange, onOpenModal, selectAll, className, }) => {
    const wrapperRef = useRef();
    useEffect(() => {
        if (!wrapperRef.current)
            return;
        const button = wrapperRef.current.querySelector('.button--active');
        if (button) {
            button.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
            });
        }
    }, [value]);
    return (_jsxs("div", Object.assign({ ref: wrapperRef, className: classNames(styles.wrapper, className) }, { children: [_jsx(Button, { mode: [...mode, 'justIcon'], className: classNames(styles.btn, styles.search), leftElement: 'search', onClick: onOpenModal }), selectAll && (_jsx(Button, Object.assign({ mode: value ? mode : modeSelected, className: styles.btn, onClick: () => onChange(null) }, { children: selectAll }))), items.map((x, index) => (_jsx(Button, Object.assign({ mode: value === x.id ? modeSelected : mode, isActive: value === x.id, className: styles.btn, onClick: () => onChange(x.id) }, { children: x.text }), index)))] })));
};
export default TabsBarMobile;
